import { HStack, VStack } from '@genial/components';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
} from '../../../../../../../../components/TableContent';
import {
  DetailsSkeleton,
  StatusSkeleton,
  TextSkeleton,
  TextWithSubtextSkeleton,
} from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { getFixedFeeColumnFlex } from '../../constants';

export const FixedFeeTermsRowLoadingDesktop: React.FC = () => {
  return (
    <VStack mx="inline.xxs">
      <TableContent direction="column" space={0} py="stack.xxs" px="inline.xxxs">
        <HStack w="full" alignItems="center">
          <TableContentItemColumn space="stack.quarck" flex={getFixedFeeColumnFlex(0)}>
            <TextSkeleton w="70%" />
            <StatusSkeleton w="60%" />
          </TableContentItemColumn>

          <TableContentItemColumn flex={getFixedFeeColumnFlex(1)}>
            <TextSkeleton w="65%" />
          </TableContentItemColumn>

          <TableContentItemColumn space="stack.quarck" flex={getFixedFeeColumnFlex(2)}>
            <TextWithSubtextSkeleton w="75%" subtextW="35%" />
          </TableContentItemColumn>

          <TableContentItemColumn flex={getFixedFeeColumnFlex(3)}>
            <TextSkeleton w="65%" />
          </TableContentItemColumn>

          <TableContentItemColumn flex={getFixedFeeColumnFlex(4)}>
            <TextSkeleton w="55%" />
          </TableContentItemColumn>

          <TableContentItemColumn flex={getFixedFeeColumnFlex(5)}>
            <TextSkeleton w="80%" />
          </TableContentItemColumn>

          <TableContentItemColumn flex={getFixedFeeColumnFlex(6)}>
            <TextSkeleton w="65%" />
          </TableContentItemColumn>

          <TableContentItemColumn flex={getFixedFeeColumnFlex(7)}>
            <HStack alignItems="center" space="inline.xxxs" w="full">
              <DetailsSkeleton />
              <DetailsSkeleton />
            </HStack>
          </TableContentItemColumn>
        </HStack>
      </TableContent>
    </VStack>
  );
};
